var exports = {
  "H": "HeroMobileCrop__Dy8puJ",
  "_": "rightAligned__X6Kg3t",
};

module.exports = exports;
